(function () {
    'use strict';

    angular.module("imApp").factory("findPersonService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1124,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
